export { default as FolderFileSolidIcon } from './FolderFileSolidIcon';
